import React, { useContext, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import loaderGif from "../../assets/mysmart-loader.gif";
import { ThemeContext } from "../../theme/ThemeContext";

function Loader() {
  const [loading, setLoading] = React.useState(false);
  const store = useSelector((state) => state);
  const { darkMode } = useContext(ThemeContext);

  useEffect(() => {
    setLoading(store.loader.loader);
  }, [store.loader.loader]);

  return (
    <>
      {!loading ? null : (
        <div className="loader-container">
          <div
            className="loader"
            style={{
              backgroundColor: darkMode ? "#021C31" : "#a09f9ff7",
            }}
          >
            <img
              src={loaderGif}
              alt="Loading..."
              style={{ width: "70px", height: "70px" }}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default Loader;
